/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';

import { Form } from '@organisms';

const ModeSelect = ({ wrapperCol, defaultMode, onSelect, mode, modes, ...props }) => (
  <Form.Item wrapperCol={{ span: 12, ...wrapperCol }} {...props}>
    <Select onSelect={onSelect} value={mode} defaultValue={defaultMode} options={modes} />
  </Form.Item>
);

export default ModeSelect;
